module.exports = __webpack_public_path__ + "img/consultation-fee-mobile-ru.108ef075.jpg";